<template>
  <div class="history-wrapper">
    <header class="history-header">
      <h1>Historial de Pagos Zelle</h1>
      <router-link to="/welcome" class="back-button">Volver al Dashboard</router-link>
    </header>
    <main class="history-content">
      <div class="filters-container">
        <input type="text" v-model="search" placeholder="Buscar por nombre, cliente..." class="search-input">
        <select v-model="statusFilter" class="filter-select">
          <option :value="null">Todos los Estados</option>
          <option v-for="status in statusOptions" :key="status" :value="status">{{ status }}</option>
        </select>
      </div>
      <div class="table-container">
        <div v-if="isLoading" class="loader"></div>
        <table v-else-if="filteredPayments.length > 0">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Monto</th>
              <th>Fecha</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="payment in filteredPayments" :key="payment._id">
              <td>{{ payment.nombre }}</td>
              <td>${{ payment.monto.toFixed(2) }}</td>
              <td>{{ new Date(payment.fecha).toLocaleString() }}</td>
              <td><span :class="`status-${payment.estatus.toLowerCase()}`">{{ payment.estatus }}</span></td>
            </tr>
          </tbody>
        </table>
        <div v-else class="no-results">
          <p>No se encontraron pagos registrados.</p>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'HistoryComponent',
  data() {
    return {
      payments: [],
      isLoading: true,
      search: '',
      statusFilter: null,
      statusOptions: ['Asignado', 'Procesado']
    };
  },
  computed: {
    filteredPayments() {
      let filtered = this.payments;

      if (this.search) {
        const searchTerm = this.search.toLowerCase();
        filtered = filtered.filter(p => 
          p.nombre.toLowerCase().includes(searchTerm)
        );
      }

      if (this.statusFilter) {
        filtered = filtered.filter(p => p.estatus === this.statusFilter);
      }

      return filtered;
    }
  },
  async created() {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user || !user.co_cli) {
      console.error('User not found or missing client ID');
      this.isLoading = false;
      return;
    }

    try {
      const apiUrl = process.env.VUE_APP_API_URL;
      const response = await axios.get(`${apiUrl}/zelle/cliente/${user.co_cli}`);
      this.payments = response.data;
    } catch (err) {
      console.error('Error fetching payment history:', err);
    } finally {
      this.isLoading = false;
    }
  }
};
</script>

<style scoped>
.history-wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #f0f2f5;
}

.history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.history-header h1 {
  font-size: 24px;
  color: #333;
  margin: 0;
}

.back-button {
  padding: 8px 16px;
  font-size: 14px;
  color: #fff;
  background-color: #42b983;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 0.3s;
}

.back-button:hover {
  background-color: #369f72;
}

.history-content {
  padding: 40px 30px;
}

.filters-container {
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
}

.search-input, .filter-select {
  padding: 12px 15px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.search-input {
  flex-grow: 1;
}

.table-container {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 30px;
}

table {
  width: 100%;
  border-collapse: collapse;
}

thead {
  background-color: #f8f9fa;
}

th, td {
  padding: 15px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

th {
  font-weight: 600;
  color: #333;
}

.status-asignado {
  color: #28a745;
  font-weight: bold;
}

.status-procesado {
  color: #007bff;
  font-weight: bold;
}

.loader {
  margin: 40px auto;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #42b983;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.no-results {
  text-align: center;
  padding: 40px;
  font-size: 18px;
  color: #666;
}
</style>
